import { postJson } from '#/utils/http/postJson';

import type {
  ApiABExperiment,
  ApiABExperimentBucketForId,
  ApiABExperimentId,
} from './types/ApiABExperiment';

export async function apiSetABExperimentBucket<
  TExperimentId extends ApiABExperimentId,
>(
  experimentId: TExperimentId,
  bucket?: ApiABExperimentBucketForId<TExperimentId>,
): Promise<ApiABExperiment<TExperimentId>[]> {
  return postJson<{
    abExperiments: ApiABExperiment<TExperimentId>[];
  }>('/data/ab/assignments', { id: experimentId, bucket }).then(
    ({ abExperiments }) => abExperiments,
  );
}
